import * as React from 'react';

import './index.scss';

interface IProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

export const Button: React.SFC<IProps> = ({ children, ...args }) => {
    return (
        <button {...args} className="button_style">{children}</button>
    );
};
